import { GroupCardAvatarContainer } from 'components/cards/styled'
import i18n from 'i18n'
import { GroupDoc, UserSettingsDoc } from 'types/api/changes'
import { Model } from 'types/model'
import { defaultGroupImage } from 'utils/api/groups'

import Avatar from './Avatar'
import * as Styled from './styled'
import { is24meApp } from 'utils/appType'
import { isConvertedGroup } from 'utils/groups'
import { isGroupArchived, isGroupDeleted } from 'utils/api/userSettings'

interface MultiAccountBadgeProps {
  className?: string
  images: string[]
  groups?: Model<GroupDoc>[]
  userSettings?: Model<UserSettingsDoc>
  groupIds?: string[]
}

export default function MultiAccountBadge(props: MultiAccountBadgeProps) {
  const dir = i18n.dir()

  let groupsForUI = [
    ...(props.groups?.filter(
      (group) =>
        !isGroupArchived(props.userSettings, group._id) &&
        !isGroupDeleted(props.userSettings, group._id)
    ) ?? [])
  ]

  if (props.groupIds) {
    groupsForUI = groupsForUI.filter((group) =>
      props.groupIds?.includes(group._id)
    )
  }

  const border = '3px'

  if (is24meApp()) return <></>

  return (
    <Styled.MultiAccountBadge data-dir={dir} className={props.className}>
      {groupsForUI?.[0] ? (
        <GroupCardAvatarContainer
          data-size="md"
          borderWidth={border}
          color={'white'}
        >
          <Avatar
            size={'md'}
            name=""
            asGroup
            img={groupsForUI[0].Photo}
            emptyPic={defaultGroupImage(groupsForUI[0])}
          />
        </GroupCardAvatarContainer>
      ) : (
        <></>
      )}
      {groupsForUI?.[1] ? (
        <GroupCardAvatarContainer
          data-size="md"
          borderWidth={border}
          color={'white'}
        >
          <Avatar
            size={'md'}
            name=""
            asGroup
            img={groupsForUI[1].Photo}
            emptyPic={defaultGroupImage(groupsForUI[1])}
          />
        </GroupCardAvatarContainer>
      ) : (
        <></>
      )}
      {groupsForUI?.[2] ? (
        <GroupCardAvatarContainer
          data-size="md"
          borderWidth={border}
          color={'white'}
        >
          <Avatar
            size={'md'}
            name=""
            asGroup
            img={groupsForUI[2].Photo}
            emptyPic={defaultGroupImage(groupsForUI[2])}
          />
        </GroupCardAvatarContainer>
      ) : (
        <></>
      )}
    </Styled.MultiAccountBadge>
  )
}
